
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import { IFlexMessageText } from '@/utils/types'
import Span from '@/components/common/flex-message/components/Span.vue'
import Icon from '@/components/common/flex-message/components/Icon.vue'

@Options({
  components: { Icon, Span },
  directives: { maska },
  emits: ['onSelectNode', 'initListNode'],
})
export default class Text extends Vue {
  @Prop()
  text!: IFlexMessageText

  @Prop()
  parentLayout!: string

  @Prop()
  direction!: string

  @Prop()
  parentPath!: string

  @Prop()
  hoverPath!: string

  @Prop()
  editPath!: string

  @Prop()
  isAdmin!: boolean

  get marginClass() {
    if (this.parentLayout === 'horizontal' || this.parentLayout === 'baseline') {
      if (this.direction === 'rtl') {
        if (this.text.margin === 'none') {
          return 'ExMgnRNone'
        } else if (this.text.margin === 'xs') {
          return 'ExMgnRXs'
        } else if (this.text.margin === 'sm') {
          return 'ExMgnRSm'
        } else if (this.text.margin === 'md') {
          return 'ExMgnRMd'
        } else if (this.text.margin === 'lg') {
          return 'ExMgnRLg'
        } else if (this.text.margin === 'xl') {
          return 'ExMgnRXl'
        } else if (this.text.margin === 'xxl') {
          return 'ExMgnRXXl'
        }
      } else {
        if (this.text.margin === 'none') {
          return 'ExMgnLNone'
        } else if (this.text.margin === 'xs') {
          return 'ExMgnLXs'
        } else if (this.text.margin === 'sm') {
          return 'ExMgnLSm'
        } else if (this.text.margin === 'md') {
          return 'ExMgnLMd'
        } else if (this.text.margin === 'lg') {
          return 'ExMgnLLg'
        } else if (this.text.margin === 'xl') {
          return 'ExMgnLXl'
        } else if (this.text.margin === 'xxl') {
          return 'ExMgnLXXl'
        }
      }
    } else {
      if (this.text.margin === 'none') {
        return 'ExMgnTNone'
      } else if (this.text.margin === 'xs') {
        return 'ExMgnTXs'
      } else if (this.text.margin === 'sm') {
        return 'ExMgnTSm'
      } else if (this.text.margin === 'md') {
        return 'ExMgnTMd'
      } else if (this.text.margin === 'lg') {
        return 'ExMgnTLg'
      } else if (this.text.margin === 'xl') {
        return 'ExMgnTXl'
      } else if (this.text.margin === 'xxl') {
        return 'ExMgnTXXl'
      }
    }
  }

  get sizeClass() {
    if (this.text.size === 'xxs') {
      return 'ExXXs'
    } else if (this.text.size === 'xs') {
      return 'ExXs'
    } else if (this.text.size === 'sm') {
      return 'ExSm'
    } else if (this.text.size === 'md') {
      return 'ExMd'
    } else if (this.text.size === 'lg') {
      return 'ExLg'
    } else if (this.text.size === 'xl') {
      return 'ExXl'
    } else if (this.text.size === 'xxl') {
      return 'ExXXl'
    } else if (this.text.size === '3xl') {
      return 'Ex3Xl'
    } else if (this.text.size === '4xxl') {
      return 'Ex4Xl'
    } else if (this.text.size === '5xl') {
      return 'Ex5Xl'
    }
    return ''
  }

  get weightClass() {
    if (this.text.weight === 'regular') {
      return 'ExWR'
    } else if (this.text.weight === 'bold') {
      return 'ExWB'
    }
    return ''
  }

  get styleClass() {
    if (this.text.style === 'normal') {
      return 'ExFntStyNml'
    } else if (this.text.weight === 'italic') {
      return 'ExFntStyIt'
    }
    return ''
  }

  get decorationClass() {
    if (this.text.decoration === 'none') {
      return 'ExTxtDecNone'
    } else if (this.text.decoration === 'underline') {
      return 'ExTxtDecUl'
    } else if (this.text.decoration === 'line-through') {
      return 'ExTxtDecLt'
    }
    return ''
  }

  get alignClass() {
    if (this.text.align === 'end') {
      return 'ExAlgE'
    } else if (this.text.align === 'center') {
      return 'ExAlgC'
    }
    return ''
  }

  get gravityClass() {
    if (this.text.gravity === 'bottom') {
      return 'grvB'
    } else if (this.text.gravity === 'center') {
      return 'grvC'
    }
    return ''
  }

  get wrapClass() {
    if (this.text.wrap) {
      return 'ExWrap'
    }
    return ''
  }

  get offsetTopClass() {
    if (this.text.offsetTop === 'none') {
      return 'ExTNone'
    } else if (this.text.offsetTop === 'xs') {
      return 'ExTXs'
    } else if (this.text.offsetTop === 'sm') {
      return 'ExTSm'
    } else if (this.text.offsetTop === 'md') {
      return 'ExTMd'
    } else if (this.text.offsetTop === 'lg') {
      return 'ExTLg'
    } else if (this.text.offsetTop === 'xl') {
      return 'ExTXl'
    } else if (this.text.offsetTop === 'xxl') {
      return 'ExTXXl'
    } else {
      return ''
    }
  }

  get offsetBottomClass() {
    if (this.text.offsetBottom === 'none') {
      return 'ExBNone'
    } else if (this.text.offsetBottom === 'xs') {
      return 'ExBXs'
    } else if (this.text.offsetBottom === 'sm') {
      return 'ExBSm'
    } else if (this.text.offsetBottom === 'md') {
      return 'ExBMd'
    } else if (this.text.offsetBottom === 'lg') {
      return 'ExBLg'
    } else if (this.text.offsetBottom === 'xl') {
      return 'ExBXl'
    } else if (this.text.offsetBottom === 'xxl') {
      return 'ExBXXl'
    } else {
      return ''
    }
  }

  get offsetStartClass() {
    if (this.direction === 'rtl') {
      if (this.text.offsetStart === 'none') {
        return 'ExRNone'
      } else if (this.text.offsetStart === 'xs') {
        return 'ExRXs'
      } else if (this.text.offsetStart === 'sm') {
        return 'ExRSm'
      } else if (this.text.offsetStart === 'md') {
        return 'ExRMd'
      } else if (this.text.offsetStart === 'lg') {
        return 'ExRLg'
      } else if (this.text.offsetStart === 'xl') {
        return 'ExRXl'
      } else if (this.text.offsetStart === 'xxl') {
        return 'ExRXXl'
      } else {
        return ''
      }
    } else {
      if (this.text.offsetStart === 'none') {
        return 'ExLNone'
      } else if (this.text.offsetStart === 'xs') {
        return 'ExLXs'
      } else if (this.text.offsetStart === 'sm') {
        return 'ExLSm'
      } else if (this.text.offsetStart === 'md') {
        return 'ExLMd'
      } else if (this.text.offsetStart === 'lg') {
        return 'ExLLg'
      } else if (this.text.offsetStart === 'xl') {
        return 'ExLXl'
      } else if (this.text.offsetStart === 'xxl') {
        return 'ExLXXl'
      } else {
        return ''
      }
    }
  }

  get offsetEndClass() {
    if (this.direction === 'rtl') {
      if (this.text.offsetEnd === 'none') {
        return 'ExLNone'
      } else if (this.text.offsetEnd === 'xs') {
        return 'ExLXs'
      } else if (this.text.offsetEnd === 'sm') {
        return 'ExLSm'
      } else if (this.text.offsetEnd === 'md') {
        return 'ExLMd'
      } else if (this.text.offsetEnd === 'lg') {
        return 'ExLLg'
      } else if (this.text.offsetEnd === 'xl') {
        return 'ExLXl'
      } else if (this.text.offsetEnd === 'xxl') {
        return 'ExLXXl'
      } else {
        return ''
      }
    } else {
      if (this.text.offsetEnd === 'none') {
        return 'ExRNone'
      } else if (this.text.offsetEnd === 'xs') {
        return 'ExRXs'
      } else if (this.text.offsetEnd === 'sm') {
        return 'ExRSm'
      } else if (this.text.offsetEnd === 'md') {
        return 'ExRMd'
      } else if (this.text.offsetEnd === 'lg') {
        return 'ExRLg'
      } else if (this.text.offsetEnd === 'xl') {
        return 'ExRXl'
      } else if (this.text.offsetEnd === 'xxl') {
        return 'ExRXXl'
      } else {
        return ''
      }
    }
  }

  get flexClass() {
    if (this.text.flex === 0) {
      return 'fl0'
    } else if (this.text.flex === 1) {
      return 'fl1'
    } else if (this.text.flex === 2) {
      return 'fl2'
    } else if (this.text.flex === 3) {
      return 'fl3'
    }
    return ''
  }

  get styles() {
    const textStyles: Record<string, string|number|undefined> = {}

    textStyles.flexGrow = this.text.flex
    textStyles.color = this.text.color
    textStyles.cursor = 'pointer'
    textStyles.top = this.text.offsetTop
    textStyles.bottom = this.text.offsetBottom
    if (this.direction === 'rtl') {
      textStyles.left = this.text.offsetEnd
      textStyles.right = this.text.offsetStart
    } else {
      textStyles.left = this.text.offsetStart
      textStyles.right = this.text.offsetEnd
    }

    return textStyles
  }

  get currentNodePath() {
    return this.parentPath + 'text'
  }

  selectText(node, path) {
    if (!this.text.contents || this.text.contents.length === 0) {
      this.selectNode(node, path)
    }
  }

  selectNode(node, path) {
    this.$emit('onSelectNode', node, path)
  }

  initListNode(path) {
    this.$emit('initListNode', path)
  }

  mounted() {
    this.initListNode(this.currentNodePath)
  }
}
